"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const resize_observer_1 = require("@juggle/resize-observer");
const ResizeObserver = window.ResizeObserver || resize_observer_1.ResizeObserver;
let hamburger = document.querySelector('.btn--hamburger');
let searchFlyout = document.querySelector('.meta--flyout-search');
let searchField = document.querySelector('#tx_solr_search');
let userFlyout = document.querySelector('.meta--flyout-user');
let mainNavigation = document.querySelector('.mainnavigation__nav');
let metaNavigation = document.querySelector('.mainnavigation__meta');
let documentBody = document.querySelector('body');
let activeMenuItem = Array.from(document.querySelectorAll('.mainnavigation__anchor'));
let searchButton = document.querySelector('.meta--search');
if (searchButton) {
    searchButton.addEventListener("click", (event) => {
        if (userFlyout) {
            (!userFlyout.classList.contains('hidden')) ? userFlyout.classList.add('hidden') : '';
        }
        event.stopImmediatePropagation();
        if (searchFlyout.classList.contains('hidden')) {
            searchFlyout.classList.remove('hidden');
            searchField.focus();
            (document.querySelector('.flyout-cover') ? document.querySelector('.flyout-cover').remove() : '');
            let searchCover = document.createElement('div');
            searchCover.classList.add('flyout-cover');
            document.querySelector('body').appendChild(searchCover);
            searchCover.addEventListener("click", (event) => {
                searchFlyout.classList.add('hidden');
                document.querySelector('.flyout-cover').remove();
            });
        }
        else {
            searchFlyout.classList.add('hidden');
            document.querySelector('.flyout-cover').remove();
        }
    });
}
let userButton = document.querySelector('.meta--user');
if (userButton) {
    userButton.addEventListener("click", (event) => {
        if (searchFlyout) {
            (!searchFlyout.classList.contains('hidden')) ? searchFlyout.classList.add('hidden') : '';
        }
        event.stopImmediatePropagation();
        if (userFlyout.classList.contains('hidden')) {
            userFlyout.classList.remove('hidden');
            (document.querySelector('.flyout-cover') ? document.querySelector('.flyout-cover').remove() : '');
            let userCover = document.createElement('div');
            userCover.classList.add('flyout-cover');
            document.querySelector('body').appendChild(userCover);
            userCover.addEventListener("click", (event) => {
                userFlyout.classList.add('hidden');
                document.querySelector('.flyout-cover').remove();
            });
        }
        else {
            userFlyout.classList.add('hidden');
            document.querySelector('.flyout-cover').remove();
        }
    });
}
if (mainNavigation) {
    hamburger.addEventListener('click', (event) => {
        (mainNavigation.classList.contains('hidden'))
            ? mainNavigation.classList.remove('hidden')
            : mainNavigation.classList.add('hidden');
        (metaNavigation.classList.contains('mainnavigation__meta--hidden'))
            ? metaNavigation.classList.remove('mainnavigation__meta--hidden')
            : metaNavigation.classList.add('mainnavigation__meta--hidden');
        if (mainNavigation.classList.contains('hidden')) {
            hamburger.classList.remove('btn--close');
            hamburger.classList.add('btn--hamburger');
            // Remove content blocker
            (documentBlocker) ? documentBlocker.remove() : '';
            (siteHeader) ? siteHeader.classList.remove('site-header--focussed') : '';
            documentBody.classList.remove('body-blocked', 'body-blocked-margin');
        }
        else {
            hamburger.classList.remove('btn--hamburger');
            hamburger.classList.add('btn--close');
        }
    });
    // Compensate for scrollbar width
    let style = document.createElement('style');
    style.appendChild(document.createTextNode('.body-blocked-margin{overflow-y: scroll;}'));
    document.head.appendChild(style);
    let mainMenuItems = Array.from(document.querySelectorAll('.mainnavigation__nav [data-toggle="dropdown"]'));
    let mainMenuFlyout = Array.from(document.querySelectorAll('[data-megamenu-flyout]'));
    const documentBlocker = document.createElement('div');
    documentBlocker.classList.add('modal__blocker');
    const siteHeader = document.querySelector('.site-header');
    mainMenuItems.forEach((item) => {
        item.addEventListener("click", (event) => {
            event.preventDefault();
            const el = event.target;
            const megaMenuTopLevelItemNumber = el.getAttribute('data-megamenu');
            mainMenuFlyout.forEach((item) => {
                let megaMenuFlyoutItemNumber = item.getAttribute('data-megamenu-flyout');
                (megaMenuTopLevelItemNumber === megaMenuFlyoutItemNumber)
                    ? (item.classList.contains('hidden'))
                        ? item.classList.remove('hidden') : item.classList.add('hidden')
                    : item.classList.add('hidden');
                if (!documentBody.querySelector('.modal__blocker')) {
                    documentBody.appendChild(documentBlocker);
                }
                if (documentBlocker) {
                    siteHeader.classList.add('site-header--focussed');
                    documentBody.classList.add('body-blocked', 'body-blocked-margin');
                }
            });
            if (el
                && !el.classList.contains('nav--center')
                && !el.classList.contains('nav--left')
                && !el.classList.contains('nav--right')) {
                // Handle re-clicks on already active items
                if (el.classList.contains('mainnavigation__anchor--active')) {
                    el.classList.remove('mainnavigation__anchor--active');
                    el.setAttribute('data-trigger-gtm-event-action', 'close');
                    // Remove content blocker
                    (documentBlocker) ? documentBlocker.remove() : '';
                    (siteHeader) ? siteHeader.classList.remove('site-header--focussed') : '';
                    documentBody.classList.remove('body-blocked', 'body-blocked-margin');
                }
                else {
                    // There might be other elements open, close them before setting current item active
                    let openElements = Array.from(document.querySelectorAll('.mainnavigation__anchor--active'));
                    openElements.forEach((item) => {
                        item.classList.remove('mainnavigation__anchor--active');
                        item.setAttribute('data-trigger-gtm-event-action', 'close');
                    });
                    el.classList.add('mainnavigation__anchor--active');
                    el.setAttribute('data-trigger-gtm-event-action', 'open');
                }
            }
            // Edge case: Handle (miss)clicks on <ul>, which are not handled by the eventListener attached to `documentBody`
            if (el
                && el.classList.contains('nav--center')) {
                el.classList.remove('mainnavigation__anchor--active');
                let anchor = activeMenuItem.find(el => (el.classList.contains('mainnavigation__anchor--active')));
                anchor.classList.remove('mainnavigation__anchor--active');
                (documentBlocker) ? documentBlocker.remove() : '';
            }
            // Handle clicks on chevron button on collapsed navigation
            if (window.innerWidth <= 991) {
                const mobileNavButtons = document.querySelectorAll('.mainnavigation__nav-item-button');
                mobileNavButtons.forEach((mobileNavButton) => {
                    mobileNavButton.addEventListener("touchstart", (event) => {
                        const el = event.target;
                        const mobileNavFlyout = el.closest('.mainnavigation__nav-item').nextElementSibling;
                        if (mobileNavFlyout.classList.contains('hidden')) {
                            mobileNavFlyout.classList.remove('hidden');
                        }
                    });
                });
            }
            event.stopPropagation();
        });
        document.addEventListener("keydown", (event) => {
            mainMenuFlyout.forEach((item) => {
                if (event.key === 'Escape') {
                    (event) ? documentBlocker.remove() : documentBody.appendChild(documentBlocker);
                    (event) ? documentBody.classList.remove('body-blocked', 'body-blocked-margin') : documentBody.classList.add('body-blocked', 'body-blocked-margin');
                    (event) ? item.classList.add('hidden') : item.classList.remove('hidden');
                    activeMenuItem.forEach((item) => {
                        (event)
                            ? item.classList.remove('mainnavigation__anchor--active')
                            : item.classList.add('mainnavigation__anchor--active');
                    });
                }
            });
        });
        documentBody.addEventListener("click", (event) => {
            const el = event.target;
            // Prevent stuff from triggering when content blocker isn't present.
            if (el.classList.contains('modal__blocker')) {
                mainMenuFlyout.forEach((item) => {
                    (!item.classList.contains('hidden')) ? item.classList.add('hidden') : '';
                    if (documentBlocker) {
                        (event) ? documentBlocker.remove() : documentBody.appendChild(documentBlocker);
                    }
                    siteHeader.classList.remove('site-header--focussed');
                    documentBody.classList.remove('body-blocked', 'body-blocked-margin');
                    const currentPage = window.location.pathname.split('/')[1];
                    activeMenuItem.find((item) => {
                        if (!item.href.includes(currentPage)) {
                            (event)
                                ? item.classList.remove('mainnavigation__anchor--active')
                                : item.classList.add('mainnavigation__anchor--active');
                        }
                        else {
                            item.classList.remove('mainnavigation__anchor--active');
                        }
                    });
                });
            }
        });
    });
    // Reshuffle DOM structure on mobile to push meta navigation below navigation construct
    if (metaNavigation) {
        const navContainer = document.querySelector('.mainnavigation__container');
        const userNav = document.querySelector('.mainnavigation__user');
        const resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                if (navContainer && window.innerWidth <= 575) {
                    navContainer.insertAdjacentElement('afterend', metaNavigation);
                }
                else {
                    userNav.insertAdjacentElement('beforebegin', metaNavigation);
                }
            });
            return;
        });
        resizeObserver.observe(metaNavigation);
    }
}
exports.default = {};
